import axios from 'axios';
import apiClient from '../index';

export const getYears = () => apiClient.get('/years');
export const getDivisions = (selectedYear: number | null) =>
  apiClient.get(`/divisions?modelYear=${selectedYear}`);
export const getModels = (selectedYear: number | null, selectedMaker: number | null) =>
  apiClient.get(`/models?modelYear=${selectedYear}&divisionId=${selectedMaker}`);
export const getSelectedModel = (modelId: number) => apiClient.get(`/styles?modelId=${modelId}`);
export const getCompareDetails = (modelId: number) => apiClient.get(`/compare?modelId=${modelId}`);
export const getConfigurationDetails = (styleId: number) =>
  apiClient.get(`/configuration?styleId=${styleId}`);
export const getStyleImages = (styleId: number) => apiClient.get(`/images?styleId=${styleId}`);
export const getOptionToggle = (configurationState: string, optionCode: string) =>
  apiClient.get(
    `/toggle-option?configurationState=${configurationState}&chromeOptionCode=${optionCode}&_t=${Date.now()}`,
  );

export const getMissingTrims = (params: {
  year: number;
  make: string;
  model: string;
  accountId: string;
}) => {
  const base = String(import.meta.env.VITE_APP_API_URL ?? '').replace(/\/$/, '');
  return axios.get(`${base}/missing-trims`, { params });
};
